import {GLOBAL} from 'common-shared';
import {IdCodeNameModel} from 'common-shared';

export class PropertyModel extends IdCodeNameModel {
  RoundingFactor?: number;
  UnitId: string;
  TypeClv: string;
  GroupClv: string;
  ChoiceTypeClassificatorId: string;
  Sequence?: number;
  ForceSave: boolean = false;
  IsMultiValue: boolean;

  constructor(init?: Partial<PropertyModel>) {
    super();
    Object.assign(this, init);
  }

  static CreateDefault(init?: Partial<PropertyModel>) {
    return Object.assign(new PropertyModel(), {
      GroupClv:GLOBAL.Classificators.PropertyGroup.General,
      RoundingFactor: null,
      TypeClv: GLOBAL.Classificators.PropertyType.Numeric
    } as PropertyModel, init);
  }

  isChoice() {
    return this.TypeClv === GLOBAL.Classificators.PropertyType.Choice;
  }

  isNumeric() {
    return this.TypeClv === GLOBAL.Classificators.PropertyType.Numeric;
  }

  isDateTime() {
    return this.TypeClv === GLOBAL.Classificators.PropertyType.DateTime;
  }

  isText() {
    return this.TypeClv === GLOBAL.Classificators.PropertyType.Text || this.TypeClv === GLOBAL.Classificators.PropertyType.Html;
  }

  isFileLink() {
    return this.TypeClv === GLOBAL.Classificators.PropertyType.FileLink;
  }
}

export class PropertyUsages {
  ItemGroups: IdCodeNameModel[];
  Items: IdCodeNameModel[];
  MasterOperations: IdCodeNameModel[];
  MasterInstructions: IdCodeNameModel[];
  ProcessSelectors: IdCodeNameModel[];
  TaskSelectors: IdCodeNameModel[];
  SalesOrders: IdCodeNameModel[];
  Resources: IdCodeNameModel[];
}
